// extracted by mini-css-extract-plugin
export default {"tableTooltip":"tableTooltip__BmqdL"};